const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:7071';
const PROPERTY_ENDPOINT = `${API_BASE}/api/property`;

export async function fetchPropertyUsers(propertyId) {
  if (!propertyId) {
    throw new Error('Property ID is required to fetch property users');
  }
  console.log('[settingsApi] requesting users with propertyId:', propertyId);
  const response = await fetch(`${PROPERTY_ENDPOINT}/users?propertyId=${encodeURIComponent(propertyId)}`);
  const body = await response.json();

  console.log('[settingsApi] received response', response.status, body);

  if (!response.ok) {
    throw new Error(body?.error || 'Failed to fetch users');
  }

  if (Array.isArray(body)) {
    return body;
  }

  if (Array.isArray(body?.users)) {
    return body.users;
  }

  return [];
}
